// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OperationalFootprintPage from "../pages/OperationalFootprint/OperationalFootprint";
const __wvcRoutePaths = ["/OperationalFootprintPage", "/operational-footprint"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["articles", "automation", "automationpage", "blogpage", "case-studies", "casestudiespage", "connect-with-us", "connectwithuspage", "home", "homepage", "operational-footprint", "operationalfootprintpage", "post", "services", "servicespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<OperationalFootprintPage />} />
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<OperationalFootprintPage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
